document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('section[id^="MainProduct-"]');
  if (!section) return;

  const checkbox    = section.querySelector('#preview-addon-checkbox');
  const previewFlag = section.querySelector('#preview-requested-flag');
  const qtyInput    = section.querySelector('input[name="quantity"]');

  // ✅ Your confirmed VARIANT ID for the add-on:
  const ADDON_VARIANT_ID = 50607630549298;

  if (!checkbox || !previewFlag) return;

  async function addAddon(qty) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: ADDON_VARIANT_ID,
            quantity: qty,
            properties: { "_addon_for": "Design preview for main item" }
          }]
        })
      });
    } catch (e) {
      console.warn('Addon add error', e);
    }
  }

  async function removeAddon() {
    try {
      // Set quantity to 0 for that variant to remove it
      const body = {};
      body[`updates[${ADDON_VARIANT_ID}]`] = 0;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json' },
        body: new URLSearchParams(body).toString()
      });
    } catch (e) {
      console.warn('Addon remove error', e);
    }
  }

  function currentQty() {
    const v = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
    return isNaN(v) ? 1 : v;
  }

  // When the checkbox changes, add or remove the add-on immediately
  checkbox.addEventListener('change', async () => {
    const checked = checkbox.checked;
    previewFlag.value = checked ? 'Yes' : 'No';

    if (checked) {
      await addAddon(currentQty());
    } else {
      await removeAddon();
    }
  });

  // Keep add-on quantity in sync if customer changes qty before adding main item
  if (qtyInput) {
    let lastQty = currentQty();
    const sync = async () => {
      const q = currentQty();
      if (q === lastQty) return;
      lastQty = q;

      if (checkbox.checked) {
        // Easiest way to sync: set all quantities in one go
        const body = {};
        body[`updates[${ADDON_VARIANT_ID}]`] = q;

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json' },
          body: new URLSearchParams(body).toString()
        });
      }
    };
    qtyInput.addEventListener('change', sync);
    qtyInput.addEventListener('input',  sync);
  }
});
